import { Component, OnInit } from '@angular/core';
import *as moment from "moment";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { EnquiryService } from 'src/app/services/Enquiry/enquiry.service';
@Component({
  selector: 'app-visitor',
  templateUrl: './visitor.component.html',
  styleUrls: ['./visitor.component.css']
})
export class VisitorComponent implements OnInit {

  VisitorID = 0;
  Update = false;
  typeaheadLoading: boolean;
  VisitorModel = {
      VisitorID: 0,
      FirstName: '',
      MiddleName: '',
      LastName: '',
      Mobile: '',
      Address: '',
      Email: '',
      INTime: moment(new Date()).format('HH:MM'),
      OUTTime:moment(new Date()).format('HH:MM'),
      OUTDate:moment(new Date()).format(this.globalHelper.DateFormat),
      Photo: null,
      PhotoPath: null,
      Remarks: '',
  }
  VisitorSearchList:any;

  SearchModel = {
    Mobile: '',
    FirstName: '',
    FromDate: '',
    ToDate: '',
    CurrentIndex: 0,
    PageSize: 20,
};
  currentPage :any= 1;
  pageSize :any= "20";
  recordCount :any= 0;
  totalPages :any= 0;
  Submitted :boolean = false;
  EnquiryNo:any='';
  VisitorList = [];
  VisitorLogID :any;
  TimeMsg:any = '';

  constructor(private enquiryService: EnquiryService, private LookupService: LookupService, public globalHelper: GlobalHelper,private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.SearchAllVisitor();
    this.GetVisitor(false);
  }

  GetVisitor(e:boolean) {
    this.typeaheadLoading = e;
  
    this.Update = false;
      var itemBo = {
          'ItemCode1': this.VisitorModel.Mobile,
      };
      this.LookupService.GetLookupsList('SearchVisitor', JSON.stringify(itemBo)).subscribe((data: any) => {
          this.VisitorSearchList = data.LookupItems;
      });
  };

  SelectedVisitor (item) {    
      this.VisitorModel.VisitorID = item.VisitorID;
      this.VisitorModel.FirstName = item.FirstName;
      this.VisitorModel.MiddleName =item.MiddleName;
      this.VisitorModel.LastName = item.LastName;
      this.VisitorModel.Mobile = item.Mobile;
      this.VisitorModel.Address = item.Address;
      this.VisitorModel.Email = item.Email;
     // this.VisitorModel.PhotoPath = item.PhotoPath;
  }

  Edit(item) {
      this.Update = true;
     this.VisitorModel.VisitorID = item.VisitorID;
     this.VisitorModel.FirstName = item.FirstName;
     this.VisitorModel.MiddleName = item.MiddleName;
     this.VisitorModel.LastName = item.LastName;
     this.VisitorModel.Mobile = item.Mobile;
     this.VisitorModel.Address = item.Address;
     this.VisitorModel.Email = item.Email;
     this.VisitorModel.PhotoPath = item.PhotoPath;
  }

  Clear  () {
    this.VisitorModel.VisitorID = 0;
    this.VisitorModel.MiddleName = '';
    this.VisitorModel.LastName = '';
    this.VisitorModel.Mobile = '';
    this.VisitorModel.Address = '';
    this.VisitorModel.Email = '';    
    this.VisitorModel.INTime = moment(new Date()).format('HH:MM'),
    this.VisitorModel.OUTTime =moment(new Date()).format('HH:MM'),
    this.VisitorModel.OUTDate = moment(new Date()).format('DD-MMM-YYYY'),
    this.VisitorModel.Photo = null;
    this.VisitorModel.PhotoPath = null;
    this.Submitted = false;
    this.VisitorID = 0;
    this.VisitorModel.FirstName = '';
  }

  
  ClearSearch = function () {
      this.SearchModel.Mobile = '';
      this.SearchModel.FromDate = '';
      this.SearchModel.ToDate = '';
  }
 
  numberOfPages  () {
    this.totalPages = Math.ceil(this.recordCount / this.pageSize);
  }

  nextPage () {
      this.currentPage = this.currentPage + 1;

  }

  pageSizes = function () {
      this.currentPage = 1;
      this.recordCount = 0;
      this.totalPages = 0;
  }
 
 
  SaveVisitor(valid) {
      this.VisitorID = 0;
      this.Submitted = true;
      if (valid) {
        this.spinnerService.show();
          this.enquiryService.SaveVisitor(JSON.stringify(this.VisitorModel)).subscribe((data: any) => {
              if (data.webResponse.Status) {
                  this.VisitorID = data.VisitorID;
              }
             this.globalHelper.CheckActionStatus(data);
             this.SearchAllVisitor();
          });
      }
  }

  ClearEnquiryNo  () {
      this.EnquiryNo = '';
  }

  PrintVisitor (Mobile) {
      var url = "../../../App/Enquiry/PrintVisitorDetails/PrintVisitorDetails.html?Mobile=" + Mobile;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
  }
  
  SearchAllVisitor  () {
    this.spinnerService.show();
      // this.SearchModel.CurrentIndex = this.currentPage;
      // this.SearchModel.PageSize = this.pageSize;
      this.enquiryService.SearchAllVisitor(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
          this.VisitorList = data.VisitorList;
          this.recordCount = 0;
          if (this.VisitorList != null && this.VisitorList.length > 0) {
              this.recordCount = this.VisitorList[0].RecordCount;
          }
          for (var i = 0; i <this.VisitorList.length; i++) {
              if (!this.VisitorList[i].IsLock) {
             //     this.VisitorList[i].OUTTime =moment(new Date()).format('HH:MM'),
               //   this.VisitorList[i].OUTDate = moment(new Date()).format('DD-MMM-YYYYY');
              }
          }
          this.spinnerService.hide();
          this.numberOfPages();
         
      });
  }

  EditVisitorLog (item) {
      this.VisitorLogID = item.VisitorLogID;
      this.TimeMsg = '';
      var OutDate = moment(new Date(item.OUTDate)).format(this.globalHelper.DateFormat);
      var VisitDate = moment(new Date(item.CreatedOn)).format(this.globalHelper.DateFormat); 
      var OutDateTime = OutDate + " " + item.OUTTime;
      var InDateTime = VisitDate + " " + item.INTime;
      
      if (new Date(OutDateTime) > new Date(InDateTime)) {
          this.enquiryService.SaveVisitorLog(JSON.stringify(item)).subscribe((data: any) => {
             this.globalHelper.CheckActionStatus(data);
              this.TimeMsg = '';
              this.SearchAllVisitor();
          });
      }     
      else {
          this.TimeMsg = 'Please enter a valid OUT Date/Time';
          return;
      }

  }
}
